import axios from 'axios';

const PUBLIC_API_URL = process.env.REACT_APP_WEBBACK_URL || 'http://localhost:8080';

const publicApi = axios.create({
  baseURL: PUBLIC_API_URL,
});

export const getLatestS3Image = async (ftpUser) => {
  try {
    const response = await publicApi.get(`/api/public/s3-images/latest`, {
      params: { ftpUser }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching latest S3 image:", error);
    throw error;
  }
};

export const getFirstS3Image = async (ftpUser) => {
  try {
    const response = await publicApi.get(`/api/public/iframe-config/${ftpUser}/first-image`);
    return response.data;
  } catch (error) {
    console.error("Error fetching first S3 image:", error);
    throw error;
  }
};

export const getMondayImages = async (ftpUser) => {
  try {
    const response = await publicApi.get(`/api/public/iframe-config/${ftpUser}/mondays`);
    return response.data;
  } catch (error) {
    console.error("Error fetching monday images:", error);
    throw error;
  }
};
